/**
 * Handler of cobrowse messages (support accept and decline cobrowse messages).
 */
/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatCobrowseMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(
		this,
		com.inq.flash.client.data.MessageFields.TYPE_CHAT_COBROWSE
	);

	/** @type {object} */
	this.xssModule = require("xss");
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler'] = com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.__name__ = [
	"com","inq","flash","client","control","messagehandlers","ChatCobrowseMessageHandler"
];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * Executes performance test with calling Inq.CBC.performanceTest()
 * Then display Cob Invitation on CI.
 *
 * @private
 * @this com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @param {string}  agentName 
 * @param {string}  chatText 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.executeCobrowseInvite = function(message,agentName,chatText) {
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);
	/** @type {Date} */
	var messageTimestamp = message.getPropertyAsDate(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP);
	com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(agentName, chatText, com.inq.flash.client.chatskins.ChatTextArea.AGENT, -1, null, replay, null, messageTimestamp);
	/*  RTDEV-2516  Need to check if messages are retrieved from the cache or */
	/*  lastAgentMessage will get called every time a new page is loaded and chat will be maximized every time */
	if (replay != "1") com.inq.flash.client.control.MinimizeManager.lastAgentMessage(chatText);
};

/**
 * Run cbc.performanceTest upon COB performance test request message.
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.executeCobrowseGetHTMLTest = function(agentId) {
	var testResult = false;
	if (Inq["CBC"]) {  // TODO use getCBC() from FlashPeer it will support persistent mode
		testResult = Inq["CBC"].testGetHTML();
	}

	this.sendCobrowseTestResult(testResult, agentId);
};

/**
 * @param testResult test result, true - passed, false - failed
 * @private
 */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.sendCobrowseTestResult = function(testResult, agentId) {
	if ( testResult ) {
		Application.application.applicationController.sendCoBrowseMessageQuietly(
			com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestSuccess,
			com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST_RESULT,
			com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_SUCCESS,
			null,
			agentId);
	} else {
		Application.application.applicationController.sendCoBrowseMessageQuietly(
			com.inq.flash.client.chatskins.CoBrowseMgr.cobrowseTestFail,
			com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST_RESULT,
			com.inq.flash.client.data.MessageFields.KEY_COB_TEST_RESULT_FAILURE,
			null,
			agentId);
	}
};

com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.handleCobrowseActionsInAttributes = function(chatText, cobrowseEvent) {
	var isCobrowseActionInAttributes = chatText.indexOf("data-nuance-cobrowse") != -1;
	if (isCobrowseActionInAttributes) {
		return this.processCobrowseActionsInAttributes(chatText, cobrowseEvent);
	}
	return chatText;
};

com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.processCobrowseActionsInAttributes = function(chatText, cobrowseEvent) {
	var cobrowseAttributeRegEx = /data-nuance-cobrowse=["'](.*?)["']/;
	var cobrowseMgrClassPath = "onclick=\"inqFrame.com.inq.flash.client.chatskins.CoBrowseMgr.";
	if (this.isCobrowseInvite(cobrowseEvent)) {
		chatText = chatText.replace(cobrowseAttributeRegEx, cobrowseMgrClassPath + "acceptCobInv(); return false;\"")
		.replace(cobrowseAttributeRegEx, cobrowseMgrClassPath + "declineCobInv(); return false;\"");		
	} else if (this.isCobrowseSharedInvite(cobrowseEvent)) {
		chatText = chatText.replace(cobrowseAttributeRegEx, cobrowseMgrClassPath + "acceptCobShareInv(); return false;\"")
		.replace(cobrowseAttributeRegEx, cobrowseMgrClassPath + "declineCobShareInv(); return false;\"");		
	}

	return chatText;
};

com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.isCobrowseInvite = function(cobrowseEvent) {
	return cobrowseEvent == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE;
};

com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.isCobrowseSharedInvite = function(cobrowseEvent) {
	return cobrowseEvent == com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_SHARED_INVITE;
};
/**
 * Process cobrowse messages (accept and decline) except message "Agent end cobrowse session".
 *
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.processMessage = function(message) {
	/** @type {string} */
	var chatText = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA);
	/** @type {?string} */
	var agentAlias = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS);
	/** @type {?string} */
	var agentId = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_USER_ID);
	/** @type {?string} */
	var quiet = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_CUSTOMER_QUIET);
	/** @type {string} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY);

	// Remove any javascript in messages. removeJSInMessages	
	chatText = this.getFilteredText(chatText);
	message.setPropertyIfNotNullIfExists(
		com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA,
		chatText
	);

	if (agentAlias != null) {
		/** @type {string} */ 
		var cobrowseEvent = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT);
		if(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_END != cobrowseEvent) {
			chatText = this.handleCobrowseActionsInAttributes(chatText, cobrowseEvent);
			chatText = this.handleCustomEventAttributes(chatText);
			if(this.isCobrowseInvite(cobrowseEvent)) {
			    this.executeCobrowseInvite(message,agentAlias,chatText);
			} else if(this.isCobrowseSharedInvite(cobrowseEvent)) {
			    this.executeCobrowseInvite(message,agentAlias,chatText);
			} else if(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_INVITE_TEST == cobrowseEvent // it's used for ATT eligibility test
			   && "1" != replay) { 
				this.executeCobrowseGetHTMLTest(agentId);
			} else if(com.inq.flash.client.data.MessageFields.KEY_COBROWSE_EVENT_TYPE_AGENT_COBROWSE_SENT_FAIL_NO_CONNECTION == cobrowseEvent // it's used for ATT eligibility test
				&& "1" != replay) {
				this.sendCobrowseTestResult(false, agentId);
			}
		} else {
			/** @type {string} */
			var agentType = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_TYPE);
			if (com.inq.flash.client.data.MessageFields.DATA_AGENT_TYPE_FLEX == agentType && "1" != replay) {
				/** @type {string} */
				var windowId = message.getProperty(com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM);
				com.inq.flash.client.chatskins.CoBrowseMgr.endCobByEtlEvent(windowId);
			}
		}
	} else {
		if (chatText === com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsCobrowse || chatText === com.inq.flash.client.chatskins.CoBrowseMgr.customerAcceptsSharedControl) {
			com.inq.flash.client.chatskins.CoBrowseMgr.ariaCobStart(replay);
		} else {
			com.inq.flash.client.chatskins.CoBrowseMgr.ariaCobEnd();
		}
		if (!quiet) {
			if (com.inq.flash.client.chatskins.SkinControl.cw != null) { // check persistent mode, when no chat window inside main window
				com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("",chatText,com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,-1, null, replay);
			}
		} else {
			try {
				com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor(com.inq.flash.client.chatskins.SkinControl.cw);
			} catch(e) {
				haxe.Log.trace("ChatCobrowseMessageHandler.processMessage: ERROR - during execution of com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor");
			}
		}
	}
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatCobrowseMessageHandler;
